import axios from '../axiosConfig'; // Assuming this is your configured Axios instance
import { API_BASE_URL } from '../config';
const baseURL = API_BASE_URL;

const getEmployeesList = async (data) => {
    var headers = {'Content-Type': 'application/json', 'Accept': 'application/json'};
    if (! axios.defaults.headers.common["Authorization"]){
      headers['Authorization'] = `Bearer ${sessionStorage.getItem("authToken")}`;
    }
  
    try {
      let url = `/office/employees?page=${data.page}&per_page=${data.per_page}`;
      
      // Add search parameter if provided
      if (data.ilike && data.ilike.trim()) {
        url += `&ilike=${encodeURIComponent(data.ilike.trim())}`;
      }
      
      console.log('Final API URL being called:', url);
      console.log('Request data received:', data);
      console.log('data.ilike value:', data.ilike);
      console.log('data.ilike exists:', !!data.ilike);
      console.log('data.ilike.trim():', data.ilike ? data.ilike.trim() : 'undefined');
      
      const response = await axios.get(url, {
        headers: headers
      });
      console.log('Employees API response:', response);
       
      return response;
    } catch (error) { 
      console.error('Error fetching employees:', error);
      return error;
    }
  }; 
  const addEmployees = async (data) => {
    var headers = {'Content-Type': 'application/json', 'Accept': 'application/json'};
    if (! axios.defaults.headers.common["Authorization"]){
      headers['Authorization'] = `Bearer ${sessionStorage.getItem("authToken")}`;
    }
  
    try {
      const response = await axios.post('/office/employees',data, {
        headers: headers
      });
      console.log(response);
      return response;
    } catch (error) { 
      return error;
    }
  };
  const getEmployeeById = async (id) => {
    var headers = {'Content-Type': 'application/json', 'Accept': 'application/json'};
    if (! axios.defaults.headers.common["Authorization"]){
      headers['Authorization'] = `Bearer ${sessionStorage.getItem("authToken")}`;
    }
  
    try {
      const response = await axios.get(`/office/employees/${id}`,{
        headers: headers
      });
      console.log(response);
      return response;
    } catch (error) { 
      return error;
    }
  };
  const updateEmployee = async (id, data) => {
    var headers = {'Content-Type': 'application/json', 'Accept': 'application/json'};
    if (! axios.defaults.headers.common["Authorization"]){
      headers['Authorization'] = `Bearer ${sessionStorage.getItem("authToken")}`;
    } 
    try {
      const response = await axios.put(`/office/employees/${id}`, data, {
        headers: headers 
      })  
      return response;
    } 
    catch (error) {
      return error; 
    }
  }
  const deleteEmployee = async (id) => {
    var headers = {'Content-Type': 'application/json', 'Accept': 'application/json'};
    if (! axios.defaults.headers.common["Authorization"]){
      headers['Authorization'] = `Bearer ${sessionStorage.getItem("authToken")}`;
    } 
    try {
      const response = await axios.put(`/office/employees/${id}`, {
        headers: headers 
      })  
      return response;
    } 
    catch (error) {
      return error; 
    }
  }
  const getMnagerListByOEMId = async (oemId,role) => {
    var headers = {'Content-Type': 'application/json', 'Accept': 'application/json'};
    if (! axios.defaults.headers.common["Authorization"]){
      headers['Authorization'] = `Bearer ${sessionStorage.getItem("authToken")}`;
    }
    try {
      const response = await axios.get(`/office/employees?oem_id=${oemId}&role=${role}`,{
        headers: headers
      }); 
      return response;
    } 
    catch (error) {
      return error; 
    }
  }
  export { getEmployeesList,addEmployees,getEmployeeById,updateEmployee,deleteEmployee,getMnagerListByOEMId,baseURL};